// extracted by mini-css-extract-plugin
export default {"PendingCancel":"H_IyJk11","Content":"JD2shCXL"};